// index.less 必须放置在 import 的 第一个
import './index.less';
import React from 'react';
import BaseLayout from '@src/layout-components/pc-layout';
import RouteEnhance from '@src/layout-components/route/route-enhance';
import routeConfigs from '@src/pages/app-router/route-configs';
import RouteSwitchEnhance from '@src/layout-components/route/route-switch-enhance';
import { HashRouter as Router } from 'react-router-dom';
import qqwxShare from '@src/components/hoc/qqwx-share';
import getDefaultShareParams from '@src/constants/share';

@qqwxShare(getDefaultShareParams())
export default class AppRouter extends React.PureComponent {
  render() {
    return (
      <Router>
        <BaseLayout>
          <RouteSwitchEnhance>{Object.keys(routeConfigs).map(key => <RouteEnhance key={key} {...routeConfigs[key]} />)}</RouteSwitchEnhance>
        </BaseLayout>
      </Router>
    );
  }
}
